import React from 'react';

const ViewReports = () => {
  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">Reports</h2>
      <p>This section will provide insights into lead generation and subscription activity.</p>
    </div>
  );
};

export default ViewReports;
